import React from 'react'
import { IoClose } from 'react-icons/io5'
import '../styles/Modal.scss'

export default function Modal({ children, isOpen, closeModal }) {

    function handleModalClick(e) {
        e.stopPropagation();
    }

    return (
        <div className={`modal ${isOpen && "is-open"}`} onClick={closeModal}>
            <div className='modal-container' onClick={handleModalClick}>
                <IoClose className='modal-close' onClick={closeModal} />
                {children}
            </div>
        </div>
    )
}

